import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clinic-footer',
  templateUrl: './clinic-footer.component.html',
  styleUrls: ['./clinic-footer.component.scss'],
})
export class ClinicFooterComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
